import PropTypes from "prop-types"
import React, { useState } from "react"
import { Alert, Form, Input, FormFeedback, Label, InputGroup, InputGroupText } from "reactstrap";
//redux
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
// actions
import { loginUser } from "../../store/actions"
import { ToastContainerHelper } from '../../helpers/alerts/alertHelper';
import { LoginArtDesktop, LoginArtMobile, LoginPin } from "./LoginArt";

const Login = props => {

  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const { error, loading } = useSelector(state => ({
    loading: state.Login.loading,
    error: state.Login.error,
  }))

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Ingresa tu correo electronico"),
      password: Yup.string().required("Ingresa tu contraseña"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.history));
    }
  });

  const emailInvalid = !!(validation.touched.email && validation.errors.email);
  const passwordInvalid = !!(validation.touched.password && validation.errors.password);

  document.title = "Iniciar sesión";
  return (
    <React.Fragment>
      <ToastContainerHelper />
      <div className="ggt-login">
        <section className="ggt-login__art" aria-label="Ilustración: recorrido con puntos de control de tiempo">
          <LoginArtDesktop />
          <LoginArtMobile />
        </section>

        <main className="ggt-login__main">
          <Form
            className="ggt-login__form"
            noValidate
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="ggt-login__brand d-none d-lg-flex">
              <LoginPin id="ggt-logo-d" />
              <div className="ggt-login__brand-text">
                <span className="ggt-login__brand-name"><b>GoGo</b> Logistic</span>
                <span className="ggt-login__brand-sub">Sistema de Logística</span>
              </div>
            </div>

            <div className="ggt-login__heading">
              <span className="ggt-doto ggt-login__eyebrow d-none d-lg-inline">ACCESO</span>
              <span className="ggt-doto ggt-login__eyebrow d-lg-none">CADA PARADA, A TIEMPO_</span>
              <h1 className="ggt-login__title">¡Bienvenido!</h1>
              <p className="ggt-login__subtitle">Introduce tus credenciales para ingresar.</p>
            </div>

            {error ? <Alert color="danger" className="mb-0">{error}</Alert> : null}

            <div className="ggt-login__field">
              <Label for="login-email" className="ggt-login__label">Correo electrónico</Label>
              <InputGroup className={`ggt-login__group${emailInvalid ? " is-invalid" : ""}`}>
                <InputGroupText className="ggt-login__addon"><i className="bx bx-user" aria-hidden="true"></i></InputGroupText>
                <Input
                  id="login-email"
                  name="email"
                  placeholder="nombre@empresa.com"
                  type="email"
                  autoComplete="username"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                  invalid={emailInvalid}
                />
              </InputGroup>
              {emailInvalid ? (
                <FormFeedback type="invalid" className="d-block">{validation.errors.email}</FormFeedback>
              ) : null}
            </div>

            <div className="ggt-login__field">
              <div className="d-flex justify-content-between align-items-center">
                <Label for="login-password" className="ggt-login__label">Contraseña</Label>
                <Link to="/forgot-password" className="ggt-login__link d-none d-lg-inline">¿Olvidaste tu contraseña?</Link>
              </div>
              <InputGroup className={`ggt-login__group${passwordInvalid ? " is-invalid" : ""}`}>
                <InputGroupText className="ggt-login__addon"><i className="bx bx-lock-alt" aria-hidden="true"></i></InputGroupText>
                <Input
                  id="login-password"
                  name="password"
                  className="ggt-login__pw"
                  value={validation.values.password || ""}
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  autoComplete="current-password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={passwordInvalid}
                />
                <button
                  type="button"
                  className="input-group-text ggt-login__eye"
                  aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                  onClick={() => setShowPassword(s => !s)}
                >
                  <i className={showPassword ? "bx bx-hide" : "bx bx-show"} aria-hidden="true"></i>
                </button>
              </InputGroup>
              {passwordInvalid ? (
                <FormFeedback type="invalid" className="d-block">{validation.errors.password}</FormFeedback>
              ) : null}
              <Link to="/forgot-password" className="ggt-login__link ggt-login__link--below d-lg-none">¿Olvidaste tu contraseña?</Link>
            </div>

            <button className="btn ggt-login__submit" type="submit" disabled={loading}>
              <i className={loading ? "bx bx-loader bx-spin" : "bx bx-log-in"} aria-hidden="true"></i>
              Iniciar sesión
            </button>

            <div className="ggt-login__footer">
              <span>© {new Date().getFullYear()} <a className="ggt-login__link" href="https://gogotrack.mx" target="_blank" rel="noopener noreferrer">GoGoTrack</a></span>
            </div>
          </Form>
        </main>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
